import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "./HeaderMob.css";
import Logo from "../../Assets/Svg/Logo.svg";
import SocialMediaIcons from "../StickySocialMedia/SocialMediaIcons";
import HeaderMobIcon from "../../Assets/Svg/HeaderMobIcon.svg";
import HeaderMobClose from "../../Assets/Svg/HeaderMobClose.svg";

export default function EnglishHeaderMobile() {
  const [showDropdown, setShowDropdown] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showDropdown && menuRef.current && !menuRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    const handleScroll = () => {
      if (showDropdown) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleScroll);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showDropdown]);

  const handleLanguageChange = () => {
    const currentPath = location.pathname;
    const isArabic = currentPath.endsWith("/ar");
    const basePath = isArabic ? currentPath.slice(0, -3) : currentPath;
    const newPath = isArabic ? basePath : `${basePath}${basePath.endsWith("/") ? "ar" : "/ar"}`;
    navigate(newPath, { replace: true });
    setShowDropdown(false);
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setShowDropdown(false);
  };

  return (
    <>
      <div className="Header_Main_Mob">
        <div className="Header_Main_Container">
          <div className="Header_Container">
            <SocialMediaIcons />
            <div className="Logo">
              <Link to="/">
                <img src={Logo} alt="Logo" className="Header_Logo_Mob" />
              </Link>
            </div>
            <div className="OpenIcon_Mob">
              <div onClick={handleLanguageChange} className="CLMob">
                AR
              </div>
              <button ref={buttonRef} className="OpenIcon_Mob_Button" onClick={toggleDropdown}>
                <img src={showDropdown ? HeaderMobClose : HeaderMobIcon} alt="MenuIcon" className="MenuIcon_Mob" />
              </button>
            </div>
          </div>
        </div>
        {showDropdown && (
          <div className="DropdownMenu" ref={menuRef}>
            <ul>
              <li onClick={() => handleNavigation("/")}>Home</li>
              <li onClick={() => handleNavigation("/about-us")}>About Us</li>
              <li onClick={() => handleNavigation("/categories")}>Categories</li>
              <li onClick={() => handleNavigation("/media")}>Media</li>
              <li onClick={() => handleNavigation("/contact-us")}>Contact Us</li>
            </ul>
          </div>
        )}
      </div>
    </>
  );
}
